import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useLanguage } from '../../../context/LanguageContext';
import './FAQ.css';

const FAQ: React.FC = () => {
  const { t } = useLanguage();
  const [openItem, setOpenItem] = useState<number | null>(0);

  const faqs = [
    {
      id: 0,
      question: t('faq.question1'),
      answer: t('faq.answer1')
    },
    {
      id: 1,
      question: t('faq.question2'),
      answer: t('faq.answer2')
    },
    {
      id: 2,
      question: t('faq.question3'),
      answer: t('faq.answer3')
    },
    {
      id: 3,
      question: t('faq.question4'),
      answer: t('faq.answer4')
    },
    {
      id: 4,
      question: t('faq.question5'),
      answer: t('faq.answer5')
    }
  ];

  const toggleItem = (id: number) => {
    setOpenItem(prev => prev === id ? null : id);
  };

  return (
    <section id="faq" className="faq-section py-5">
      <Container>
        <div className="text-center mb-5">
          <div className="luxury-title-container">
            <h2 className="luxury-section-title">{t('faq.title')}</h2>
            <div className="luxury-underline"></div>
          </div>
          <p className="luxury-subtitle">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="faq-grid">
          {faqs.map((faq) => (
            <div 
              key={faq.id} 
              className={`faq-card ${openItem === faq.id ? 'active' : ''}`}
              onClick={() => toggleItem(faq.id)}
            >
              <div className="faq-question">
                <h4>{faq.question}</h4>
                <div className="faq-icon">
                  <span className={`icon-line ${openItem === faq.id ? 'rotated' : ''}`}></span>
                  <span className={`icon-line ${openItem === faq.id ? 'rotated' : ''}`}></span>
                </div>
              </div>
              <div className={`faq-answer ${openItem === faq.id ? 'expanded' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default FAQ;
